export default __webpack_public_path__ + "static/media/twi_alphabet.056032fb.wav";